import { useParams } from "react-router-dom";

export const useSourceEditPageParams = () => {
  const { siteSlug = "", sourceSlug = "" } = useParams();

  return { siteSlug, sourceSlug };
};
